<template>
  <div class="app">
    <div class="swiper-container">
      <Preload :isLoaded="isLoaded" @startTourist="startTourist" />
      <div class="swiper-wrapper">
        <!-- <div class="swiper-slide">
        </div> -->
        <div class="swiper-slide">
          <One @mounted="handleChildMounted" @slideNext="slideNext" ref="slide1" :isActive="activeIndex === 0" />
        </div>
        <!-- <div class="swiper-slide" data-hash="slide2">
          <Two @mounted="handleChildMounted" :isActive="activeIndex === 2" />
        </div> -->
        <div class="swiper-slide">
          <Three @mounted="handleChildMounted" @slidePrev="slidePrev" @slideNext="slideNext" :isActive="activeIndex === 1" />
        </div>
        <div class="swiper-slide">
          <Four
            @mounted="handleChildMounted"
            @slidePrev="slidePrev"
            @slideNext="slideNext"
            @pauseMusic="pauseMusic"
            @playMusic="playMusic"
            :isActive="activeIndex === 2"
          />
        </div>
        <div class="swiper-slide">
          <Five @mounted="handleChildMounted" @slidePrev="slidePrev" @slideNext="slideNext" :isActive="activeIndex === 3" />
        </div>
        <div class="swiper-slide" data-hash="slide5">
          <Six @mounted="handleChildMounted" @slidePrev="slidePrev" :isActive="activeIndex === 4" />
        </div>
      </div>
    </div>

    <div class="music-player" @click="toggleMusic" v-show="musicPlayerShow"></div>
    <audio ref="audio" src="https://htdrp.oss-cn-hangzhou.aliyuncs.com/one-trip/2020-06-24-11-27-42-htwz-ebd5vs804cm.mp3"></audio>
  </div>
</template>

<script>
import Swiper from 'swiper'
import anime from 'animejs'
import Preload from './components/Preload'

export default {
  data() {
    return {
      isLoaded: false, // 是否加载完
      resolvedCount: 0, // 已经加载完成的组件
      isStarted: false, // 是否开始浏览，由用户点击开始
      isPlaying: false, // 是否在播放音乐
      musicPlayerShow: true,  // 是否展示旋转的播放器
      activeIndex: -1, // 活跃的下标
      preloadShow: true,
    }
  },
  components: {
    Preload,
    One: () => import('./components/One'),
    // Two: () => import('./components/Two'),
    Three: () => import('./components/Three'),
    Four: () => import('./components/Four'),
    Five: () => import('./components/Five'),
    Six: () => import('./components/Six'),
  },
  mounted() {
    this.playMusic();
  },
  methods: {
    // 子组件挂载事件
    handleChildMounted() {
      this.resolvedCount += 1
      if (this.resolvedCount !== 5) return
      this.isLoaded = true
    },
    startTourist() {
      if (this.isStarted) {
        return;
      }
      const vm = this;
      this.swiper = new Swiper('.swiper-container', {
        direction: 'vertical',
        speed: 500,
        hashNavigation: true,
        allowTouchMove: false,
        on: {
          slideChange() {
            vm.activeIndex = this.activeIndex;
          }
        }
      });
      if (location.hash !== '#slide5') {
        this.activeIndex = 0;
      }
    },
    playMusic() {
      this.isPlaying = true;
      this.$refs.audio.play();
      if (this.musicAnimation) {
        this.musicAnimation.play()
        return
      }
      this.musicAnimation = anime({
        targets: '.music-player',
        rotateZ: ['0deg', '360deg'],
        loop: true,
        easing: 'linear',
        duration: 3000
      })
    },
    pauseMusic() {
      this.isPlaying = false;
      this.$refs.audio.pause();
      if (this.musicAnimation) {
        this.musicAnimation.pause()
      }
    },
    toggleMusic() {
      if (this.isPlaying) {
        this.pauseMusic();
      } else {
        this.playMusic();
      }
    },
    // 下一页
    slideNext() {
      this.swiper && this.swiper.slideNext();
    },
    // 上一页
    slidePrev() {
      this.swiper && this.swiper.slidePrev();
    },
  }
}
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  font-family: 'Microsoft Yahei', Arial, Helvetica, sans-serif;
  font-size: 16px;
}
</style>
<style lang="scss">
.app {
  // width: 100vw;
  max-width: 1024px;
  height: 100vh;
  margin: 0 auto;
  overflow: hidden;
}
.swiper-container {
  width: 100%;
  height: 100%;
  background:  #f2f2f2;
}
.music-player {
  z-index: 999999;
  position: fixed;
  top: 25px;
  right: 18px;
  width: 31px;
  height: 36px;
  background: url(~@/assets/player.png) center center / 100% 100% no-repeat;
  cursor: pointer;
}
</style>
